import { render, staticRenderFns } from "./give-gift.vue?vue&type=template&id=657663c1"
import script from "./give-gift.vue?vue&type=script&lang=js"
export * from "./give-gift.vue?vue&type=script&lang=js"
import style0 from "./give-gift.vue?vue&type=style&index=0&id=657663c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports